import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DeliveredNotifications, PushNotifications } from '@capacitor/push-notifications';
import { storageKeys } from 'src/app/enum/storage-keys';
import { ApiService } from '../api/api.service';
import { BadgeService } from '../badge/badge.service';
import { CurrentPlatformService } from '../current-platform/current-platform.service';
import { StorageService } from '../storage/storage.service';
import { ProfileService } from '../profile/profile.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(
    private router: Router,
    private storage: StorageService,
    private apiService: ApiService,
    private currentPlatformService: CurrentPlatformService,
    private badgeService: BadgeService,
    private profileService: ProfileService
  ) { }

  async initPush() {
    try {
      if (this.currentPlatformService.isNative()) {
        await this.badgeService.init();
        await this.addListeners();
        await this.registerNotifications();
      }
    } catch (e) {
      console.log(e);
      console.log('Error Notification or No Permissions Give!');
      throw(e);
    }
  }


  private addListeners = async () => {

    try{
      await PushNotifications.addListener('registration', async (_token) => {
        console.info('Registration token: ', _token.value);

        if ((await this.getNotificationToken()) == null) await this.storage.setStorage(storageKeys.FCMTOKENS, _token.value);
        if (!(await this.profileService.getProfileInfo()).notification_token){
          await this.apiService.collection('fcm-tokens').add(Object.assign({ token: _token.value }));
          await this.profileService.updateProfile({notification_token: _token.value})
        }

      });

      await PushNotifications.addListener('registrationError', err => {
        console.error('Registration error: ', err.error);
      });

      await PushNotifications.addListener('pushNotificationReceived', async (notification) => {
        console.log('Push notification received: ', notification);

        await this.badgeService.increase(1);
      });

      await PushNotifications.addListener('pushNotificationActionPerformed', async (notification) => {

        const notificationSchema = notification.notification;

        // get DeliveredNotifications and remove it
        const deliveredId: DeliveredNotifications | any = await this.getDeliveredNotifications(notificationSchema.id);
        if (deliveredId) {
          await this.removeDeliveredNotifications(deliveredId);
        }

        if (notificationSchema.data.id) {
          this.router.navigateByUrl(notificationSchema.data.id);
        }
      });
    }catch(e){
      throw(e);
    }


  }

  private registerNotifications = async () => {
    try {
      let permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
      }

      if (permStatus.receive !== 'granted')
        throw new Error('User denied permissions!');

      await PushNotifications.register();
    } catch (e) {
      throw (e);
    }
  }

  async getNotificationToken() {
    try {
      const token = (await this.storage.getStorage(storageKeys.FCMTOKENS)).value;
      return token ? token : null
    } catch (e) {
      throw (e);
    }
  }


  getDeliveredNotifications = async (id: string) => {
    try {
      const notificationList = await PushNotifications.getDeliveredNotifications();
      const index = notificationList.notifications.findIndex(n => n.id == id);
      return index != -1 ? notificationList[index] : null;
    } catch (e) {
      throw (e);
    }


  }


  async removeDeliveredNotifications(delivered: DeliveredNotifications) {
    try {
      await PushNotifications.removeDeliveredNotifications(delivered);
      this.badgeService.decrease(1);
    } catch (e) {
      throw (e);
    }


  }

  async removeAllDeliveredNotifications() {
    try {
      if (this.currentPlatformService.isNative()) {
        const len = (await PushNotifications.getDeliveredNotifications()).notifications.length
        if(len){
          await PushNotifications.removeAllDeliveredNotifications();
          await this.badgeService.clear();
        }
      }
    } catch (e) {
      throw (e);
    }
  }

  async isNotificationAllowed(){
    let permStatus = await PushNotifications.checkPermissions();
    console.log('checkPermissions() -----> ', permStatus);
    return permStatus.receive == 'denied' ? false : true;
  }




}
